export default __webpack_public_path__ + "static/media/Reader's Boots of the Exiled.a16f3ade.jpg";